<section
  class="emoji-mart {{ darkMode ? 'emoji-mart-dark' : '' }}"
  [style.width]="getWidth()"
  [ngStyle]="style"
>
  <div class="emoji-mart-bar">
    <emoji-mart-anchors
      [categories]="categories"
      (anchorClick)="handleAnchorClick($event)"
      [color]="color"
      [selected]="selected"
      [i18n]="i18n"
      [icons]="categoriesIcons"
    ></emoji-mart-anchors>
  </div>
  @if (enableSearch) {
  <emoji-search
    #searchRef
    [i18n]="i18n"
    (searchResults)="handleSearch($event)"
    (enterKey)="handleEnterKey($event)"
    [include]="include"
    [exclude]="exclude"
    [custom]="custom"
    [autoFocus]="autoFocus"
    [icons]="searchIcons"
    [emojisToShowFilter]="emojisToShowFilter"
  ></emoji-search>
  }
  <section
    #scrollRef
    class="emoji-mart-scroll"
    (scroll)="handleScroll()"
    [attr.aria-label]="i18n.emojilist"
  >
    @for (category of activeCategories; track categoryTrack(idx, category); let
    idx = $index) {
    <emoji-category
      #categoryRef
      [id]="category.id"
      [name]="category.name"
      [emojis]="category.emojis"
      [perLine]="perLine"
      [totalFrequentLines]="totalFrequentLines"
      [hasStickyPosition]="isNative"
      [i18n]="i18n"
      [hideObsolete]="hideObsolete"
      [notFoundEmoji]="notFoundEmoji"
      [custom]="
        category.id == RECENT_CATEGORY.id ? CUSTOM_CATEGORY.emojis : undefined
      "
      [recent]="category.id == RECENT_CATEGORY.id ? recent : undefined"
      [emojiIsNative]="isNative"
      [emojiSkin]="skin"
      [emojiSize]="emojiSize"
      [emojiSet]="set"
      [emojiSheetSize]="sheetSize"
      [emojiForceSize]="isNative"
      [emojiTooltip]="emojiTooltip"
      [emojiBackgroundImageFn]="backgroundImageFn"
      (emojiOver)="handleEmojiOver($event)"
      (emojiLeave)="handleEmojiLeave()"
      (emojiClick)="handleEmojiClick($event)"
    ></emoji-category>
    }
  </section>
</section>
